define('flight-components/FlashMessage',[
  'App',
  'flight/lib/component'
],

function(App, defineComponent){

  var FlashMessage = function FlashMessage() {


    this.defaultAttrs({
      closeButtonSelector: '.flash-message__close-btn'
    });

    this.closeMessage = function (ev, data) {
      this.$node.remove();
    };

    this.after('initialize', function() {

      var self = this;
      this.on('click', {
        'closeButtonSelector': this.closeMessage
      });

    });

  };

  return defineComponent(FlashMessage);
});
